import type { Proyecto } from "../api/types";
import { BadgeEstado } from "./BadgeEstado";
import estilos from "./ListaProyectos.module.css";

interface Props {
  proyectos: Proyecto[];
  onAbrir: (id: string) => void;
  onNuevo: () => void;
}

// Fecha corta legible, ej. "16 jul, 04:46".
function formatearFecha(iso: string): string {
  const fecha = new Date(iso);
  if (Number.isNaN(fecha.getTime())) return "";
  return fecha.toLocaleString("es", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function ListaProyectos({
  proyectos,
  onAbrir,
  onNuevo,
}: Props): JSX.Element {
  return (
    <section className={estilos.seccion} aria-label="Tus proyectos">
      <header className={estilos.encabezado}>
        <h2>Tus proyectos</h2>
        <span className={estilos.contador}>
          {proyectos.length === 1
            ? "1 proyecto"
            : `${proyectos.length} proyectos`}
        </span>
      </header>

      {proyectos.length === 0 ? (
        <div className={estilos.vacio}>
          <p>Todavia no creaste ningun flyer.</p>
          <button
            type="button"
            className="boton boton-primario"
            onClick={onNuevo}
          >
            Crear el primero
          </button>
        </div>
      ) : (
        <ul className={estilos.lista}>
          {proyectos.map((p) => (
            <li key={p.id}>
              <button
                type="button"
                className={estilos.fila}
                onClick={() => onAbrir(p.id)}
                title={`Abrir ${p.brief}`}
              >
                <span className={estilos.brief}>{p.brief}</span>
                <span className={estilos.formato}>{p.format}</span>
                <BadgeEstado estado={p.estado} />
                <span className={estilos.fecha}>
                  {formatearFecha(p.updated_at)}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
